import logo from './logo.svg';
import './App.css';
import Index from './components/Index';
import Home from './components/Home';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MegaDropdowntest from './components/MegaDropdowntest';
import ModernFooter from './components/ModernFooter'
import ServicesTabSection from './ServiceTabSection';
import AboutUsPage from './components/AboutUsPage';
import ContactUsPage from './components/ContactUsPage';
import LeadtechPrinters from './components/LeadtechPrinters';
import TIJPrintersSection from './components/TIJPrintersSection';
import HanshowESL from './components/HandshowESL';
import SavemaTTO from './components/SavemaTTO';
import LaserPrinter from './components/LaserPrinter';
import IndustrialScalesPage from './components/IndustrialScalePages';
import EASAntennaSection from './components/EASAntennaSection';
import Retail_scales from './components/Retail_scales';
import RetailWeighingScale from './components/RetailWeighingScale';
import BarcodeProducts from './components/BarcodeProducts';
import Mobiletheft from './components/Mobiletheft';
import Mobiletheftproduct from './components/Mobiletheftproduct';
import MobileSecurity from './components/MobileSecurity';
import SunmiClaude from './components/SunmiClaude';


function App() {
  return (
    <div className="">
      <BrowserRouter>
        <MegaDropdowntest/>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/services' element={<ServicesTabSection/>}/>
          <Route path='/aboutus' element={<AboutUsPage/>}/>
          <Route path='/contactus' element={<ContactUsPage/>}/>
          <Route path='/LT' element={<LeadtechPrinters/>}/>
          <Route path='/TIJ' element={<TIJPrintersSection/>}/>
          <Route path="/ESL" element={<HanshowESL/>}/>
          <Route path='/TTO' element={<SavemaTTO/>}/>
          <Route path='/Laser' element={<LaserPrinter/>}/>
          <Route path='/Industrial' element={<IndustrialScalesPage/>}/>
          <Route path='/EAS System' element={<EASAntennaSection/>}/>
          <Route path='/retail_weighing' element={<Retail_scales/>}/>
          <Route path='/retail-weighing-scale' element={<RetailWeighingScale/>}/>
          <Route path='/barcode-products' element={<BarcodeProducts/>}/>
          <Route path='/mobile-theft' element={<Mobiletheft/>}/>
          <Route path='/Productshowcase' element={<Mobiletheftproduct/>}/>
          <Route path='/mobile-security-devices' element={<MobileSecurity/>}/>
          <Route path='/sunmi-devices' element={<SunmiClaude/>}/>
        </Routes>
        <ModernFooter/>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
